import { login, getMe } from '@/api/user';
import { getToken, setToken, removeToken, setUserInfo, removeUserInfo } from '@/utils/auth';
import router, { resetRouter } from '@/router';

const state = {
  token: getToken(),
  userInfo: {},
  roles: '',
  admin: false,
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  GET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_ADMIN: (state, admin) => {
    state.admin = admin;
  },
};

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo;
    return new Promise((resolve, reject) => {
      // let response = {
      //   token:'123123123',
      //   user:{
      //       id: 1,
      //       username: 'admin',
      //       password: 'admin',
      //       email: '123456@qq.com',
      //       name: 'tizdata'
      //   }
      // }
      // setToken(response.token)
      // setUserInfo(response.user)
      login({ username: username.trim(), password: password })
        .then((response) => {
          commit('SET_TOKEN', response.token);

          setToken(response.token);
          setUserInfo(response.user);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  userinfo({ commit }) {
    return new Promise((resolve, reject) => {
      // commit('SET_ROLES', 2)
      // commit('GET_USER_INFO', {})
      // resolve(2)
      getMe()
        .then((response) => {
          console.log(response);
          const { agent_info, is_staff, is_superuser } = response;
          let roles = 'none';
          let allow_offline = false;
          let is_maintainer = false;
          let allow_oem = false;
          let allow_xzreport = false;
          let allow_af = false;
          if (agent_info) {
            roles = agent_info.status;
            allow_offline = agent_info.allow_offline;
            is_maintainer = agent_info.is_maintainer;
            allow_oem = agent_info.allow_oem;
            allow_xzreport = agent_info.allow_xzreport;
            allow_af = agent_info.allow_af;
          }
          //response.roles = roles
          commit('SET_ROLES', roles);
          commit('SET_ADMIN', is_staff);
          commit('GET_USER_INFO', response);
          setUserInfo(response);
          resolve({
            agent_info:agent_info,
            roles: roles,
            admin: is_staff,
            allow_oem: allow_oem,
            is_superuser: is_superuser,
            allow_offline,
            is_maintainer,
            allow_xzreport,
            allow_af,
          });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  logout({ commit, state }) {
    return new Promise((resolve) => {
      commit('SET_TOKEN', '');
      commit('SET_ADMIN', false);
      commit('SET_ROLES', []);
      removeToken();
      removeUserInfo();
      resetRouter();
      resolve();
    });
  },
  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      commit('SET_TOKEN', '');
      commit('SET_ADMIN', false);
      commit('SET_ROLES', '');
      removeToken();
      removeUserInfo();
      resolve();
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js